import {showMessage} from 'exsportia-components'

import {l} from '../utils/i18n'
import {AddonErrorLike, getAddonErrorMessage} from './addon-error'

// For the booking forms' onError: shows the sentence and says it handled the error. The customer stays on the
// booking and changes the add-ons at the Participants step.
export const handleAddonInvalidError = (error?: AddonErrorLike | null): boolean => {
  const message = getAddonErrorMessage(error, (key, options) => l(key, options))
  if (!message) {
    return false
  }
  showMessage(message, 'error')
  return true
}
